
export const TO_BE_PLANNED = 12;
export const PLANNED = 11;
export const IN_PROGRESS = 8;
export const PRE_PLANNED = 13;
export const ON_HOLD = 94;
export const CANCELLED = 88;
export const RE_USED = 95;
export const CLOSED = 9;
export const CREATED = 6;

export enum PlanningStatus {
  TO_BE_PLANNED = "12",
  PLANNED = "11",
  IN_PROGRESS = "8",
  PRE_PLANNED = "13",
  ON_HOLD = "94",
  CANCELLED = "88",
  RE_USED = "95",
  CLOSED = "9",
  CREATED = "6"
}

export const PlanningStatusDisplay = {
  toBePlanned: { name: "To be planned", value: TO_BE_PLANNED },
    onHold: { name: "On hold", value: ON_HOLD },
    
}

/**
 * Statuses that keep a planning block out of the REUSE candidate flow: it is finished
 * (closed, cancelled, already reused) or parked on hold.
 */
export const REUSE_INELIGIBLE_STATUS_TYPES: number[] = [CLOSED, CANCELLED, RE_USED, ON_HOLD];

/**
 * REUSE MODULE V2 offers an import planning block for every remaining status - created,
 * to be planned, pre-planned, planned and in progress - so a planner can match an export
 * order before the import block is completed. Without V2 the original rule stands: only
 * TO_BE_PLANNED blocks take part.
 *
 * The decision is made on the planning block status alone. Per-action (order line)
 * status is deliberately not consulted: it is not part of the planning block payload.
 */
export function isReuseEligiblePlanningBlockStatus(statusType: number, useReuseModuleV2: boolean): boolean {
  return useReuseModuleV2
    ? !REUSE_INELIGIBLE_STATUS_TYPES.includes(statusType)
    : statusType === TO_BE_PLANNED;
}
